<template>
  <v-container fluid>
    <h2>{{ $t('create_energy_price_set') }}</h2>
    <energy-price-set-form @saved="energyPriceSetCreated($event)"></energy-price-set-form>
  </v-container>
</template>

<script>
import EnergyPriceSetForm from '@/components/energy/EnergyPriceSetForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  components: {EnergyPriceSetForm},
  mixins: [BrowserUtilitiesMixin],
  mounted() {
    this.updateBrowserTitle(this.$t('create_energy_price_set'))
  },
  methods: {
    energyPriceSetCreated(energyPriceSet) {
      this.$router.push('/energy-price-set/' + energyPriceSet.id, () => {
        this.$store.dispatch(
          'globalMessagingModule/showSuccessFlashBanner',
          `${this.$i18n.tc('energy_price_set')} ${this.$i18n.t('generic_save_success')}`
        )
      })
    }
  }
}
</script>

<style>
</style>
